import { useQuery } from 'common/hooks';
import { getOrganizationObjectivesApi } from '../objectives.service';
import { ObjectiveResponse } from '../types/objective.type';

export const useGetOrganizationObjectives = () => {
  const queryResponse = useQuery(['organization-objectives'], getOrganizationObjectivesApi, {
    select: (response) => ({
      ...response,
      data: response.data.objectives as ObjectiveResponse[],
    }),
  });

  return {
    ...queryResponse,
    data: queryResponse?.data?.data,
  };
};
